import { createFileRoute, Navigate } from '@tanstack/react-router';
import { pageTitle, usePageTitle } from '@/utils/pageTitle';
import { WarehouseTable } from '@/components/Pages/Warehouses/WarehouseTable';
import { CreateEditWarehouseModal } from '@/components/Pages/Warehouses/CreateEditWarehouseModal';
import { Box } from '@mui/joy';
import { useAuth } from '@/contexts/AuthContext';

export const Route = createFileRoute('/_protected/warehouses/')({
  component: WarehousesPage,
  head: () => pageTitle('Sucursales'),
});

function WarehousesPage() {
  usePageTitle('Sucursales');
  const { hasClaim, isLoading } = useAuth();
  const canRead = hasClaim('WAREHOUSE_READ');
  const canWrite = hasClaim('WAREHOUSE_WRITE');

  if (!isLoading && !canRead) {
    return <Navigate to='/' />;
  }

  return (
    <Box>
      {canWrite && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
          <CreateEditWarehouseModal />
        </Box>
      )}
      <WarehouseTable />
    </Box>
  );
}
